import React from 'react';
import { useHistory } from 'react-router-dom';

import './mobile-main-header-style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

// Components
import { ImageButton } from '@atoms';
import CartQuantityIcon from '@src/componentsNew/Icons/CartQuantityIcon/CartQuantityIcon';
import WishlistIcon from '@src/componentsNew/Icons/Icons/WishlistIcon';
import MobileSearchInput from '@src/componentsNew/Inputs/MobileSearchInput';

// images & icons
import Logo from '@src/imagesNew/logo/maccaron-logo.jpg';
import GlobalStoreLogo from '@src/imagesNew/logo/global-store-logo.png';

// constants
import { baseUrl, accountUrl, wishListUrl, cartUrl, offersUrl, mobileMainMgsTabUrl } from '@src/app/routes';

const MobileMainHeader = () => {
  const history = useHistory();
  const isComDomain = useIsComDomain();
  const currentPath = history.location.pathname;

  const pathsNotShowCartIcon = [baseUrl, offersUrl, mobileMainMgsTabUrl, accountUrl];
  const shouldNotShowCartIcon = pathsNotShowCartIcon.findIndex((path) => path === currentPath) !== -1 ? true : false;

  return (
    <header id="mobile-main-header">
      <div className="mobile-header-content-wrapper">
        <ImageButton href={baseUrl} imgSrc={isComDomain ? GlobalStoreLogo : Logo} width={isComDomain ? '180' : '120'} />
        <div className="mobile-header-my-menu-wrapper">
          <WishlistIcon onClick={() => history.push(wishListUrl)} />
          {!shouldNotShowCartIcon ? <CartQuantityIcon isMobile={true} onClick={() => history.push(cartUrl)} /> : null}
        </div>
      </div>

      <MobileSearchInput isSearchPage={false} />
    </header>
  );
};

export default MobileMainHeader;
